import CalendarController from './CalendarController'
import CellFieldController from '../../lib/CellFieldController'
import CellController, { CellComponent } from '../../lib/CellController'
import { makeCal } from '../../../../maurice/components/tableu/lib-js'

export default CalendarController

/** @constructor @extends {CalendarController} @suppress {checkTypes} */ function _CalendarController() {}
CalendarController.__implement(
 CellFieldController,
 _CalendarController.prototype = /** @type {!CalendarController} */ ({
  paint() { // to availability in month/year
   const{
    availabilityLoader:{state:{availability=[]}},state:{month,year},
    asICellFieldController:{
     asIOccupiableCellFieldController:{occupy,clearOccupied,drawOccupied},
    },
   }=this
   const required=[]
   for (const av of availability) {
    // draw some cells
    let{start,end}=av
    // let ss
    const st = {}
    const sy = start.getFullYear()
    if (sy == year) {
     const sm = start.getMonth()
     if (sm == month) {
      const s = start.getDate()
      st.s = s
     }
    }
    const ey = end.getFullYear()
    if (ey == year)  {
     const em = end.getMonth()
     if (em == month) {
      const d = end.getDate()
      required.push({ s: st.s, e: d })
     }
    }
    const flat = required.reduce((acc, { s, e }) => {
     let dd = e - s
     acc.push(s)
     while (dd > 0) {
      acc.push(s + dd)
      dd--
     }
     return acc
    }, [])
    clearOccupied()
    occupy(flat)
    drawOccupied()
   }
   // console.log(availability)
  },
 }),
 _CalendarController.prototype = /** @type {!CalendarController} */ ({
  cancel(withRange=true){
   let{
    superCellFieldController:{cancel},
    asICalendarController:{cancelStart,cancelEnd},
   }=this
   cancel()
   cancelStart(withRange)
   cancelEnd(withRange)
  },
  cancelStart(withRange=true) {
   let{
    superCellFieldController:{cancelStart},
    asIDateRanger:{dateRange},
   }=this
   cancelStart()
   if(withRange)dateRange.setState({startDate:null,range:0})
  },
  cancelEnd(withRange=true) {
   let{
    superCellFieldController:{cancelEnd},
    asIDateRanger:{dateRange},
   }=this
   cancelEnd()
   if(withRange)dateRange.setState({endDate:null,range:0})
  },
  selectStart(start) {
   let{
    superCellFieldController:{selectStart},
    asICellFieldController:{selectEnd},
    asICellFieldController:{state:{canSelectRange}},
    asICalendarController:{state:{year,month,endNextDay}},
    asIDateRanger:{dateRange},
   }=this
   selectStart(start)

   // const startDate = new Date(year, month, start, startHour)
   dateRange.setState({startDate:start,startYear:year,startMonth:month})

   // if selecting night, select end + 1
   // how to know if selecting night
   if (endNextDay) {
    selectEnd(start+1)
   } else if (!canSelectRange) {
    selectEnd(start)
   }
  },
  selectEnd(end) {
   let{
    superCellFieldController:{selectEnd},
    asICellFieldController:{state:{start,canSelectRange}},
    asICalendarController:{state:{year,month}},
    asIDateRanger:{dateRange},
   }=this
   selectEnd(end)

   // const endDate = new Date(year,month,end,endHour)
   dateRange.setState({endYear:year,endMonth:month,endDate:end})
   if (canSelectRange) {
    const range=end-start
    dateRange.setState({range})
   } else {
    dateRange.setState({range:1})
   }
  },
  reinitCellField() {
   // create new rows
   const cal = makeCal({
    year:this.state.year,
    month: this.state.month,
   })
   const tdTemplate=this.querySelector('template')
   this.CalendarBody.innerHTML=''
   // console.log(this.CalendarBody)
   const isThisMonth=this.isThisMonth()
   for(const r of cal) {
    const row=document.createElement('tr')
    for(const ds of r) {
     const tdClone=tdTemplate.content.cloneNode(true)
     const dd = ds.replace(/^-/, '')
     tdClone.querySelector('span').innerHTML=dd
     tdClone.querySelector('td').dataset['number']=dd
     const past=isThisMonth && (this.today.getDate() - parseInt(dd,10) > 0)
     if(past||dd=='') tdClone.querySelector('td').dataset['past']=past
     else delete tdClone.querySelector('td').dataset['past']
     row.appendChild(tdClone)
    }
    this.CalendarBody.appendChild(row)
   }
   this.CalendarBody.appendChild(tdTemplate)
   // debugger
   const cells=this.initCellField()
   this.attachListenersToCells(cells)
  },
  isThisMonth() {
   const isThisMonth=this.today.getMonth()==this.state.month && this.today.getFullYear()==this.state.year
   return isThisMonth
  },
  initCellField() {
   const{asICellFieldController:{cellField}}=this

   const classes = CellComponent.getClasses(this.props.splendid)

   // when changing month, can scrap all cells and start over
   const isThisMonth=this.isThisMonth()
   // debugger

   /** @type {!Array<!HTMLTableCellElement>} */
   const tds = [...this.querySelectorAll('[data-number]')]
   const cells = tds.map((td) => {
    const _number = td.dataset['number']
    const number = _number ? parseInt(_number, 10) : undefined
    // const past = 'past' in td.dataset || undefined
    // const DATE = td.dataset['date']
    // const number = parseInt(DATE, 10)
    // debugger
    const cell=CellController.control(td, {
     shadow: true,
     classes:classes,
     state: {
      past: isThisMonth && (this.today.getDate() - number > 0),
     },
     props: {
      number:number,
     },
    })
    return cell
   })
   cellField.superCellField.initialiser({
    cells,
   })
   return cells
  },
  attachListenersToCells(cells) {
   const {
    asICalendarController:{cancel},
    asICellFieldController:{
     project:project,
     selectEnd:selectEnd,
     cancelEnd:cancelEnd,
     selectStart:selectStart,
     cancelStart:cancelStart,
     clearProjected:clearProjected,
     clearProjectedEnds:clearProjectedEnds,
    },
   } = this
   for (const cell of cells) {
    const{props:{number:date},element:cellElement}=cell
    cellElement.addEventListener('click', () => {
     const{
      asICellFieldController:{
       props:{disabled},
       occupied,
       state:{
        start,end,uiState,canSelectRange, // should can select range be a property [semantic]
       }},
      asICalendarController:{
       state:{year,month},today,
      },
     }=this
     if (disabled) return
     const dd = new Date(year, month, date)
     if (dd.getTime() < today.getTime()) {
      return
     }

     if (occupied.has(date)) {
      alert("Невозможно зарезервировать " + date + ", т.к. дата забронирована.")
      return
     }
     if (uiState == 'selected' && canSelectRange) {
      if (date == end) {
       cancelEnd()
      }
      else if (date > start) {
       selectEnd(date)
      }
     } else if (uiState == 'selected' && !canSelectRange) {
      if (date != start) {
       cancel(false)
       selectStart(date)
      } else {
       cancel()
      }
     }
     else if (uiState == 'selectingStart') { // initial state, no selection happened
      selectStart(date)
     }
     else if (uiState == 'selectingEnd') {
      if (date == start) {
       cancelStart()
      } else if (date > start) {
       selectEnd(date)
       clearProjectedEnds()
      }
     }
    })
    cellElement.addEventListener('mouseenter', () => {
     if (this.state.uiState == 'selectingEnd') {
      project(date)
     }
    })
    cellElement.addEventListener('mouseleave', () => {
     if (this.state.uiState == 'selectingEnd') {
      clearProjected()
     }
    })
   }
  },
  __$constructor() {
   const cells=this.initCellField()
   this.attachListenersToCells(cells)
  },
 }),
)
